import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { EnquiryProvider } from "@/components/Enquiry";
import Home from "@/pages/Home";
import ServiceDetail from "@/pages/ServiceDetail";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";

function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
      <AuthProvider>
        <BrowserRouter>
          <EnquiryProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/admin/login" element={<Login />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </EnquiryProvider>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
